export const OPTMIZELY_GRAPHQL_BASE_URL = 'https://cg.optimizely.com/content/v2?auth=';
export const DEFAULT_FETCH_PARAMS = { headers: { 'Content-Type': 'application/json' } };
